import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../colorVars';
import { modifySoftOrder } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/modifySoftOrders';
import { updatePlugins } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/updatePlugins';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import { CancelOrderButton } from '../../../../../../../atomic/buttons/cancelOrderButton/CancelOrderButton';
import IncrementButton from '../../../../../../../atomic/buttons/incrementButton/IncrementButton';
import { EditableTableField } from '../../../../../../../atomic/inputs/editableTableField/EditableTableField';
import { Body3 } from '../../../../../../../atomic/text/Text';
import { IndividualPanelHeader } from '../IndividualPanelHeader';
import style from '../IndividualTacticStyle.module.css';

export const GrabCentsTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => { 
    const [addCent, setAddCent] = useState(0);
    const [addSecondValue, setAddSecondValue] = useState(0);
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const tacticId = tradePlan.exitTactics['GRAB_CENTS']?.tacticId ?? null;
    const inPosition = tradePlan?.inPosition ?? null;
    const softOrder = tradePlanStore.softOrdersById[tacticId] ?? null;
    const softOrderTrailAmount =
      softOrder?.value.tacticValue.trailAmount ?? null;

    const centsPerLevel =
      tradePlan?.exitTactics['GRAB_CENTS']?.centsPerLevel ?? null;
    const percentagePerLevel =
      tradePlan?.exitTactics['GRAB_CENTS']?.percentagePerLevel ?? null;
    const quantityPerLevel =
      tradePlan.exitTactics['GRAB_CENTS']?.quantityPerLevel ?? null;
    const trailAmount =
      tradePlan?.exitTactics['GRAB_CENTS']?.trailAmount ?? null;
    const trailPercent =
      tradePlan?.exitTactics['GRAB_CENTS']?.trailPercent ?? null;
    const trailQuantity =
      tradePlan?.exitTactics['GRAB_CENTS']?.trailQuantity ?? null;
    const takeProfitMode =
      tradePlan?.exitTactics['GRAB_CENTS']?.takeProfitMode ?? null;
    let unit;
    if (percentagePerLevel)
      unit = percentagePerLevel.length > 0 ? 'percent' : 'quantity';
    else unit = 'quantity';

    const updateSoftOrder = (type, value) => {
      modifySoftOrder({ softOrder, type, value });
    };

    const updateTactic = (field, newValue) => {
      updatePlugins(
        'tactic',
        { [field]: newValue },
        'GRAB_CENTS',
        tradePlanId,
        null
      );
    };
    if (!tradePlan?.exitTactics['GRAB_CENTS']) return null;
    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <IndividualPanelHeader />
            {inPosition && softOrder !== null ? (
              <tbody>
                <tr>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Trail Amount
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    {takeProfitMode === 'DOLLARS' ? (
                      <Body3
                        fontWeight={700}
                        color={colors.lightGrey}
                        margin="3px 3px 0 0"
                      >
                        $
                      </Body3>
                    ) : null}
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={
                        takeProfitMode === 'DOLLARS'
                          ? softOrderTrailAmount
                          : Number(softOrderTrailAmount) * 100
                      }
                      updateValue={(newValue) =>
                        updateSoftOrder(
                          'trailAmount',
                          takeProfitMode === 'DOLLARS'
                            ? newValue
                            : Number(newValue) / 100
                        )
                      }
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                    {takeProfitMode === 'PERCENT' ? (
                      <Body3
                        fontWeight={700}
                        color={colors.lightGrey}
                        margin="3px 3px 0 0"
                      >
                        %
                      </Body3>
                    ) : null}
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            ) : inPosition ? (
              <tbody>
                <tr>
                  <td colSpan={4}>
                    <Body3 color={colors.lightGrey} fontWeight={700}>
                      You must wait for Grab Cents to engage before editing. You
                      can edit orders using orders table.
                    </Body3>
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      {unit === 'percent' ? 'Trail Percent' : 'Trail Qty.'}
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    {unit === 'quantity' ? (
                      <Body3
                        fontWeight={700}
                        color={colors.lightGrey}
                        margin="3px 3px 0 0"
                      >
                        #
                      </Body3>
                    ) : null}
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={
                        unit === 'percent'
                          ? Number(trailPercent) * 100
                          : trailQuantity
                      }
                      updateValue={(newValue) =>
                        updateTactic(
                          unit === 'percent' ? 'trailPercent' : 'trailQuantity',
                          takeProfitMode === 'DOLLARS'
                            ? newValue
                            : Number(newValue) / 100 //newValue
                        )
                      }
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                    {unit === 'percent' ? (
                      <Body3
                        fontWeight={700}
                        color={colors.lightGrey}
                        margin="3px 3px 0 0"
                      >
                        %
                      </Body3>
                    ) : null}
                  </td>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Trail Amount
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    {takeProfitMode === 'DOLLARS' ? (
                      <Body3
                        fontWeight={700}
                        color={colors.lightGrey}
                        margin="3px 3px 0 0"
                      >
                        $
                      </Body3>
                    ) : null}
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={
                        takeProfitMode === 'DOLLARS'
                          ? trailAmount
                          : Number(trailAmount) * 100
                      }
                      updateValue={(newValue) =>
                        updateTactic(
                          'trailAmount',
                          takeProfitMode === 'DOLLARS'
                            ? newValue
                            : Number(newValue) / 100
                        )
                      }
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                    {takeProfitMode === 'PERCENT' ? (
                      <Body3
                        fontWeight={700}
                        color={colors.lightGrey}
                        margin="3px 3px 0 0"
                      >
                        %
                      </Body3>
                    ) : null}
                  </td>
                </tr>
                {centsPerLevel.map((dollarAmount, index) => {
                  return (
                    <tr key={dollarAmount}>
                      <td className={style.labelTd}>
                        <Body3 fontWeight={700} color={colors.lightGrey}>
                          {`Cent ${index + 1}`}
                        </Body3>
                      </td>
                      <td className={style.inputTd}>
                        {takeProfitMode === 'DOLLARS' ? (
                          <Body3
                            fontWeight={700}
                            color={colors.lightGrey}
                            margin="3px 3px 0 0"
                          >
                            $
                          </Body3>
                        ) : null}
                        <EditableTableField
                          inputType="number"
                          bodySize={3}
                          initialValue={
                            takeProfitMode === 'DOLLARS'
                              ? dollarAmount
                              : Number(dollarAmount) * 100
                          }
                          updateValue={(newValue) => {
                            const centsCopy = [...centsPerLevel];
                            centsCopy[index] =
                              takeProfitMode === 'DOLLARS'
                                ? newValue
                                : Number(newValue) / 100;
                            updateTactic('centsPerLevel', centsCopy);
                          }}
                          color={colors.lightGrey}
                          backgroundColor="inherit"
                        />
                        {takeProfitMode === 'PERCENT' ? (
                          <Body3
                            fontWeight={700}
                            color={colors.lightGrey}
                            margin="3px 3px 0 0"
                          >
                            %
                          </Body3>
                        ) : null}
                      </td>

                      <td className={style.labelTd}>
                        <Body3 fontWeight={700} color={colors.lightGrey}>
                          {`${unit === 'percent' ? 'Percent' : 'Quantity'} ${
                            index + 1
                          }`}
                        </Body3>
                      </td>
                      <td className={style.inputTd}>
                        <EditableTableField
                          inputType="number"
                          bodySize={3}
                          initialValue={
                            unit === 'percent'
                              ? Number(percentagePerLevel[index]) * 100
                              : quantityPerLevel[index]
                          }
                          updateValue={(newValue) => {
                            const arrCopy =
                              unit === 'percent'
                                ? [...percentagePerLevel]
                                : [...quantityPerLevel];
                            arrCopy[index] =
                              unit === 'percent'
                                ? Number(newValue) / 100
                                : newValue;
                            updateTactic(
                              unit === 'percent'
                                ? 'percentagePerLevel'
                                : 'quantityPerLevel',
                              arrCopy
                            );
                          }}
                          color={colors.lightGrey}
                          backgroundColor="inherit"
                        />
                        <CancelOrderButton
                          width={15}
                          clickHandler={() => {
                            const filteredArr = [...centsPerLevel].filter(
                              (item, i) => i !== index
                            );
                            updateTactic('centsPerLevel', filteredArr);
                            if (unit === 'percent') {
                              const filteredPercentageArr = [
                                ...percentagePerLevel,
                              ].filter((item, i) => i !== index);
                              updateTactic(
                                'percentagePerLevel',
                                filteredPercentageArr
                              );
                            } else {
                              const filteredQuantityArr = [
                                ...quantityPerLevel,
                              ].filter((item, i) => i !== index);
                              updateTactic(
                                'quantityPerLevel',
                                filteredQuantityArr
                              );
                            }
                          }}
                        />
                      </td>
                    </tr>
                  );
                })}
                <tr>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Add Cent
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={addCent}
                      updateValue={(newValue) => setAddCent(newValue)}
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                  </td>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      {`Add ${unit === 'percent' ? 'Percent' : 'Quantity'}`}
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={addSecondValue}
                      updateValue={(newValue) =>
                        setAddSecondValue(() => {
                          if (unit === 'percent') return newValue * 100;
                          else return newValue;
                        })
                      }
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                    <IncrementButton
                      color={colors.white}
                      backgroundColor={colors.blue}
                      width={10}
                      stroke={1}
                      handleClick={() => {
                        const centsCopy = [...centsPerLevel];
                        centsCopy.push(
                          takeProfitMode === 'DOLLARS'
                            ? addCent
                            : Number(addCent) / 100
                        );
                        updateTactic('centsPerLevel', centsCopy);
                        const arrCopy =
                          unit === 'percent'
                            ? [...percentagePerLevel]
                            : [...quantityPerLevel];
                        arrCopy.push(addSecondValue);
                        updateTactic(
                          unit === 'percent'
                            ? 'percentagePerLevel'
                            : 'quantityPerLevel',
                          arrCopy
                        );
                      }}
                      buttonWidth={15}
                    />
                  </td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
      </TabPanel>
    );
  }
);
GrabCentsTacticPanel.tabsRole = 'TabPanel';
